module.exports = __webpack_public_path__ + "static/img_4765-b187b7dce49f4deee6ac6d343019eb39.webp";